<template>
  <v-card
    outlined
    max-height="100%"
    min-height="auto"
  >
    <v-card-text class="text-center">
      <v-row>
        <v-col
          cols="12"
          md="3"
          sm="12"
          class="pa-1"
        >
          <v-btn
            icon
            class="info--text"
            @click="allProducts"
          >
            <v-icon v-text="'mdi-reload'" />
          </v-btn>
          <v-slide-item
            v-for="item in categories"
            :key="item.id"
            v-slot:default="{ active, toggle }"
          >
            <v-card
              outlined
              :class="item.products.length < 1 ? 'lowQty' : 'highQty'"
              height="65"
              width="auto"
              @click="toggle"
            >
              <div
                class="d-flex"
                @click="lanchProducts(item, true)"
              >
                <div
                  cols="4"
                  class="pa-1"
                >
                  <v-img
                    :src="'/storage/' + item.image"
                    lazy-src="/storage/default_img/no_image.png"
                    aspect-ratio="1"
                    max-width="55"
                    max-height="55"
                  >
                    <template v-slot:placeholder>
                      <v-layout
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        />
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <div
                  cols="8"
                  class="pa-1 text-center"
                >
                  <h4>{{ item.name | truncate(15) | capitalize }}</h4>
                </div>
              </div>
            </v-card>
          </v-slide-item>
        </v-col>
        <v-col
          cols="12"
          md="9"
          sm="12"
        >
          <v-row v-if="category">
            <v-chip-group column>
              <v-chip
                color="green"
                filter
                outlined
                active
                @click="lanchProducts(category)"
              >
                <strong class="mr-1">"{{ category.name | capitalize }}"</strong>
              </v-chip>
              <v-chip
                v-for="child in children"
                :key="child.id"
                filter
                :color="posSelling.productSkin"
                @click="lanchProducts(child)"
              >
                {{ child.name }}
              </v-chip>
            </v-chip-group>
          </v-row>
          <v-row>
            <!-- Products listing -->
            <v-card
              v-for="product in products.slice(0, posSelling.posProductsLimit)"
              :key="product.id"
              :class="'product ml-1 mb-1 ' + posSelling.productSkin"
              :disabled="product.qty < 1 && isOverSelling"
            >
              <v-card-text class="text-center px-1 pt-1 pb-1">
                <v-img
                  :src="'/storage/' + product.image"
                  lazy-src="/storage/default_img/no_image.png"
                  aspect-ratio="1"
                  max-width="100"
                  max-height="100"
                  @click="
                    addCart(product);
                    product.qty > 0 ? product.qty-- : '';
                  "
                >
                  <template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      />
                    </v-layout>
                  </template>
                </v-img>
                <template v-if="posSelling.productName">
                  <template v-if="product.qty > 9">
                    {{ product.name | truncate(12) | capitalize }}
                  </template>
                  <template v-else>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-badge
                            bordered
                            color="error"
                            :content="product.qty"
                          >
                            {{ product.name | truncate(12) | capitalize }}
                          </v-badge>
                        </div>
                      </template>
                      <span>{{ product.qty }} remains in current stock</span>
                    </v-tooltip>
                  </template>
                </template>
              </v-card-text>
            </v-card>
            <!-- end -->

            <!-- Custom Products listing -->
            <v-card
              v-for="customItem in customProducts"
              :key="customItem.id + customItem.key"
              class="ml-1 mb-1 warning product"
              :disabled="customItem.qty < 1"
            >
              <v-card-text
                class="text-center px-1 pt-1 pb-1"
                @click="addCart(customItem) && customItem.qty--"
              >
                <v-img
                  :src="'/storage/' + customItem.image"
                  lazy-src="/storage/default_img/no_image.png"
                  aspect-ratio="1"
                  max-width="100"
                  max-height="100"
                >
                  <template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      />
                    </v-layout>
                  </template>
                </v-img>
                {{ customItem.name | truncate(12) | capitalize }}
              </v-card-text>
            </v-card>
            <!-- end -->
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      children: [],
      products: [],
      categories: {},
      category: "",
      customProducts: {},
    };
  },
  computed: {
    ...mapGetters({
      posSelling: "configs/pos",
    }),

    isOverSelling() {
      return this.posSelling.overSelling;
    },
  },
  mounted() {
    window.axios.get("/categories-for-pos").then((response) => {
      this.$data.categories = response.data.categories;
    });
    window.axios.get("/custom-products-for-pos").then((response) => {
      this.$data.customProducts = response.data.items;
    });
    this.allProducts();
  },

  methods: {
    ...mapActions({
      addCart: "cart/add",
      alert: "snackbar/show",
    }),

    allProducts() {
      window.axios.get("/products-for-pos").then((response) => {
        Event.$emit("prepareSearchSuggestions", response.data.products);
        if (this.posSelling.posAutoLoadProducts) {
          this.$data.products = response.data.products;
        }
        this.$data.category = "";
      });
    },
    lanchProducts(category, child = null) {
      this.$data.products = category.products;
      if (child) {
        this.$data.category = category;
        this.$data.children = category.children;
      }
      this.alert(
        category.name + " has " + category.products.length + " product(s)"
      );
    },
  },
};
</script>

<style type="text/css" scoped="">
.lowQty {
  border-color: red;
  margin-bottom: 1px;
  cursor: not-allowed;
}
.highQty {
  border-color: green;
  margin-bottom: 2px;
}
</style>
